__turbopack_context__.v({
  "description": "gui-module-scss-module__wNXr4q__description",
  "gui": "gui-module-scss-module__wNXr4q__gui",
  "leva": "gui-module-scss-module__wNXr4q__leva",
  "links": "gui-module-scss-module__wNXr4q__links",
  "open": "gui-module-scss-module__wNXr4q__open",
  "title": "gui-module-scss-module__wNXr4q__title",
  "toggle": "gui-module-scss-module__wNXr4q__toggle",
});
